// /src/components/LogoutHandler.js

import React, { useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../authContext';
import { setBlockLoginAutoRedirect } from '../authSessionStorage';

function isLoginPath() {
  const path = window.location.pathname || '';
  return path === '/login' || path.startsWith('/login/');
}

function LogoutHandler() {
    const { setIsLoggedIn } = useAuth();

    useEffect(() => {
        const handleLogoutEvent = () => {
            setIsLoggedIn(false);
        };

        const handleForceLogout = async (event) => {
            const reason = event?.detail?.reason;
            console.warn('[LogoutHandler] Force logout:', event?.detail);
            setIsLoggedIn(false);

            // Admin lock is env-local. Cookies/sessions are shared with other envs
            // (e.g. prod). Never revoke or clear shared auth cookies for this reason.
            if (reason === 'admin-lock') {
                setBlockLoginAutoRedirect();
                if (!isLoginPath()) {
                    window.location.assign('/login?error=restricted');
                }
                return;
            }

            setBlockLoginAutoRedirect();

            try {
                await axios.post(
                    '/api/logout-on-error',
                    { confirmed: true },
                    { withCredentials: true }
                );
            } catch (err) {
                console.warn('[LogoutHandler] logout-on-error failed:', err?.message || err);
            }

            if (!isLoginPath()) {
                window.location.assign('/login');
            }
        };

        window.addEventListener('logout-401', handleLogoutEvent);
        window.addEventListener('auth:force-logout', handleForceLogout);

        return () => {
            window.removeEventListener('logout-401', handleLogoutEvent);
            window.removeEventListener('auth:force-logout', handleForceLogout);
        };
    }, [setIsLoggedIn]);

    return null;
}

export default LogoutHandler;
